
            const data = {"name":"add","data":{"width":"20","height":"20","viewBox":"0 0 20 20","data":"<path pid=\"0\" d=\"M10 7v3-3Zm0 3v3-3Zm0 0h3-3Zm0 0H7h3Zm9 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z\" _stroke=\"#7D92A7\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#7D92A7"}],"stopColors":[]}}
        
                    module.exports = data
                    